var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner tw-animate-spin tw-icon tw-icon-laden"})
}
var staticRenderFns = []

export { render, staticRenderFns }